import UnsereVision from "./slides/UnsereVision";
import UnsereVisionAntwort from "./slides/UnsereVisionAntwort";

export default function Vision() {
  return [
    <UnsereVision key="unsere-vision" />,
    <UnsereVisionAntwort key="unsere-vision-antwort" />,
  ];
}
